export default "__VITE_ASSET__cu6ZwuMm__"